<section class="guild-switcher" aria-label="Servers">
  <header class="guild-switcher__header">
    <h2 class="guild-switcher__title">
      {{ i18n + '.servers.title' | translate }}
    </h2>
    <button
      type="button"
      class="guild-switcher__add-btn"
      (click)="toggleCreateForm()"
    >
      {{ i18n + '.servers.add' | translate }}
    </button>
  </header>

  @if (showCreateForm()) {
    <form class="guild-switcher__form" (ngSubmit)="submitCreateForm()">
      <label class="guild-switcher__field">
        <span class="guild-switcher__field-label">
          {{ i18n + '.servers.nameLabel' | translate }}
        </span>
        <input
          class="guild-switcher__field-input"
          type="text"
          name="serverName"
          [ngModel]="newServerName()"
          (ngModelChange)="newServerName.set($event)"
          [placeholder]="i18n + '.servers.namePlaceholder' | translate"
          maxlength="120"
          required
        />
      </label>
      <div class="guild-switcher__form-actions">
        <button
          type="submit"
          class="guild-switcher__submit-btn"
          [disabled]="isAdding() || !newServerName().trim()"
        >
          {{
            isAdding()
              ? (i18n + '.servers.saving' | translate)
              : (i18n + '.servers.save' | translate)
          }}
        </button>
        <button
          type="button"
          class="guild-switcher__cancel-btn"
          (click)="toggleCreateForm()"
        >
          {{ i18n + '.servers.cancel' | translate }}
        </button>
      </div>
    </form>
  }

  @if (errorKey(); as key) {
    <p class="guild-switcher__message guild-switcher__message--error" role="alert">
      {{ i18n + '.servers.errors.' + key | translate }}
    </p>
  }

  @if (isLoading()) {
    <p class="guild-switcher__message">
      {{ i18n + '.servers.loading' | translate }}
    </p>
  } @else if (guilds().length === 0) {
    <p class="guild-switcher__message">
      {{ i18n + '.servers.empty' | translate }}
    </p>
  } @else {
    <div class="guild-switcher__list" role="tablist">
      @for (guild of guilds(); track guild.registryId) {
        <button
          type="button"
          class="guild-switcher__card"
          role="tab"
          [attr.aria-selected]="guild.registryId === selectedRegistryId()"
          [class.guild-switcher__card--active]="
            guild.registryId === selectedRegistryId()
          "
          (click)="selectGuild(guild.registryId)"
        >
          <span class="guild-switcher__card-name">{{ guild.displayName }}</span>
          <span
            class="guild-switcher__card-status"
            [attr.data-status]="guild.status"
          >
            {{ i18n + '.status.' + guild.status | translate }}
          </span>
        </button>
      }
    </div>
  }
</section>
